import script from "./LinkQr.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkQr.vue?vue&type=script&setup=true&lang=js"

import "./LinkQr.vue?vue&type=style&index=0&id=bfcc264a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfcc264a"]])

export default __exports__